<template>
  <div class="discount-container" v-loading.fullscreen.lock="fullscreenLoading">
    <div>
      <span class="label">买手店：</span><span class="value">{{routeQuery.name}}</span>
      <span class="label" v-if="routeQuery.eventName">活动名称：</span><span class="value" v-if="routeQuery.eventName">{{routeQuery.eventName}}</span>
      <span class="label">类目分类：</span><span class="value">{{routeQuery.categoryType==1?'Adult':'Kids'}}</span>
      <span class="label">季节：</span><span class="value">{{routeQuery.season}}{{routeQuery.co == '0' ? '' : '(CO)'}}</span>
      <template v-if="page === 'daily'">
        <span class="label">状态：</span><span class="value">{{routeQuery.status==1?'待生效':'生效中'}}<span v-if="hasPending"> (<span class="red">有待生效折扣</span>)</span></span>
      </template>
      <template v-if="supplyPriceMethod ">
        <span class="label">价格接入方式：</span><span class="value">{{supplyPriceMethod === '0' ? "Discount" : supplyPriceMethod === '2' ? "Cost" : ""}}</span>
      </template>
    </div>
    <div class="mt15" style="height: 32px;flex-shrink: 0;">
      <template v-if="(changedTable1 || changedTable2 || changedTable3) && routeQuery.status!='5' && (page === 'daily' && submitBtnDaily || page === 'promotion' && submitBtnPromotion)">
        <span class="f14 red">当前折扣设置有变动，请全部修改完成后提交</span>
        <el-button type="primary" size="small" class="ml20" @click="submitPage">提交</el-button>
        <el-button type="primary" size="small" @click="reset">放弃全部修改</el-button>
      </template>
    </div>
    <el-alert class="mt15 mb10" style="flex-shrink: 0;" title="注：折扣均以off形式显示" type="warning"></el-alert>

    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="二级类目" name="first"></el-tab-pane>
      <el-tab-pane label="三级类目" name="second"></el-tab-pane>
      <el-tab-pane label="特殊商品" name="third"></el-tab-pane>
    </el-tabs>

    <div class="toolbar">
      <p class="f14 gray" v-if='activeName=="first"'>共 {{tableData1.length}} 条</p>
      <p class="f14 gray" v-if='activeName=="second"'>共 {{tableData2.length}} 条</p>
      <p class="f14 gray" v-if='activeName=="third"'>共 {{tableData3.length}} 条</p>
      <el-button type="primary" size="small" plain @click="onClickAdd">添加</el-button>
    </div>

    <div class="table-container" v-loading="loading">
      <VirtualScrollTable ref="VirtualScrollTable1" v-if='activeName=="first"' key="firstTable" :rowHeight="48" :resetTop="false" height="100%" :data="tableData1">
        <el-table-column prop="brandId" label="品牌" class-name="nopadding">
          <template slot-scope="scope">
            <template v-if="scope.row.brandId.value == 0">Default</template>
            <template v-else>
              <div class="item-cell" :class="{error: scope.row.brandId.error, 'changed': scope.row.brandId.value != scope.row.brandId.oldValue}"
                v-if="!scope.row.brandId.isEdit"
                @click="onClickCell1(scope, 'brandId', $event)"
              >{{ brandMap[scope.row.brandId.value] }}&nbsp;</div>
              <BrandSelect
                v-else
                :data="brandList"
                v-model="scope.row.brandId.value"
                :disabledIds="getDisabledBrandIds1(scope.row.brandId.value)"
                @change="checkTableData1"
                filterable
              ></BrandSelect>
            </template>
          </template>
        </el-table-column>
        <el-table-column v-for="(item, index) in header" :key="index" :label="item.label" align="right" class-name="nopadding">
          <template slot-scope="scope">
            <div class="item-cell" :class="{error: scope.row[item.value].error, 'changed': scope.row[item.value].value != scope.row[item.value].oldValue}"
              v-if="!scope.row[item.value].isEdit"
              @click="onClickCell1(scope, item.value, $event)"
            >{{ scope.row[item.value].value }}&nbsp;</div>
            <el-input
              v-else
              :ref="'input-' + scope.row.originIndex + '-' + item.value"
              v-model="scope.row[item.value].value"
              @input="(val) => inputNum(val, scope.row[item.value])"
              @change="checkTableData1"
              @click.native.stop=""
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="error" width="50">
          <template slot-scope="scope">
            <el-popover
              v-if="scope.row.error"
              placement="top-start"
              width="200"
              trigger="hover"
              :content="scope.row.errorMessage">
              <i slot="reference" class="el-icon-warning red"></i>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="error" width="40">
          <template slot-scope="scope">
            <i v-if="scope.row.brandId.value != 0" class="el-icon-remove-outline" @click="onClickRemove1(scope)"></i>
          </template>
        </el-table-column>
      </VirtualScrollTable>

      <VirtualScrollTable ref="VirtualScrollTable2" v-if='activeName=="second"' key="secondTable" :rowHeight="48" :resetTop="false" height="100%" :data="tableData2">
        <el-table-column prop="brandId" label="品牌" class-name="nopadding">
          <template slot-scope="scope">
            <div class="item-cell" :class="{error: scope.row.brandId.error, 'changed': scope.row.brandId.value != scope.row.brandId.oldValue}"
              v-if="!scope.row.brandId.isEdit"
              @click="onClickCell2(scope, 'brandId', $event)"
            >{{ brandMap[scope.row.brandId.value] }}&nbsp;</div>
            <BrandSelect
              v-else
              :data="brandListWithDefault"
              v-model="scope.row.brandId.value"
              @change="checkTableData2"
              filterable
            ></BrandSelect>
          </template>
        </el-table-column>
        <el-table-column prop="categoryId" label="类目" class-name="nopadding">
          <template slot-scope="scope">
            <div class="item-cell" :class="{error: scope.row.categoryId.error, 'changed': scope.row.categoryId.value != scope.row.categoryId.oldValue}"
              v-if="!scope.row.categoryId.isEdit"
              @click="onClickCell2(scope, 'categoryId', $event)"
            >{{ categoryMap[scope.row.categoryId.value] }}&nbsp;</div>
            <el-cascader
              v-else
              v-model="scope.row.categoryId.value"
              @change="checkTableData2"
              :options="categoryList"
              :props="optionProps"
              @click.native.stop=""
              :style="{width: '100%'}"
            ></el-cascader>
          </template>
        </el-table-column>
        <el-table-column prop="discount" label="折扣" class-name="nopadding" align="right">
          <template slot-scope="scope">
            <div class="item-cell" :class="{error: scope.row.discount.error, 'changed': scope.row.discount.value != scope.row.discount.oldValue}"
              v-if="!scope.row.discount.isEdit"
              @click="onClickCell2(scope, 'discount', $event)"
            >{{ scope.row.discount.value }}&nbsp;</div>
            <el-input
              v-else
              :ref="'input-' + scope.row.originIndex + '-discount'"
              v-model="scope.row.discount.value"
              @input="(val) => inputNum(val, scope.row.discount)"
              @change="checkTableData2"
              @click.native.stop=""
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="empty" label="" class-name="nopadding"></el-table-column>
        <el-table-column prop="error" width="50">
          <template slot-scope="scope">
            <el-popover
              v-if="scope.row.error"
              placement="top-start"
              width="200"
              trigger="hover"
              :content="scope.row.errorMessage">
              <i slot="reference" class="el-icon-warning red"></i>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="error" width="40">
          <template slot-scope="scope">
            <i class="el-icon-remove-outline" @click="onClickRemove2(scope)"></i>
          </template>
        </el-table-column>
      </VirtualScrollTable>

      <VirtualScrollTable ref="VirtualScrollTable3" v-if='activeName=="third"' key="thirdTable" :rowHeight="48" :resetTop="false" height="100%" :data="tableData3">
        <el-table-column prop="designerId" label="商品货号" class-name="nopadding">
          <template slot-scope="scope">
            <div class="item-cell" :class="{error: scope.row.designerId.error, 'changed': scope.row.designerId.value != scope.row.designerId.oldValue}"
              v-if="!scope.row.designerId.isEdit"
              @click="onClickCell3(scope, 'designerId', $event)"
            >{{ scope.row.designerId.value }}&nbsp;</div>
            <el-input
              v-else
              :ref="'input-' + scope.row.originIndex + '-designerId'"
              v-model="scope.row.designerId.value"
              @change="onChangeDesignId(scope.row.designerId.value, scope.row.designerId)"
              @click.native.stop=""
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="colorCode" label="颜色编码" class-name="nopadding">
          <template slot-scope="scope">
            <div class="item-cell" :class="{error: scope.row.colorCode.error, 'changed': scope.row.colorCode.value != scope.row.colorCode.oldValue}"
              v-if="!scope.row.colorCode.isEdit"
              @click="onClickCell3(scope, 'colorCode', $event)"
            >{{ scope.row.colorCode.value }}&nbsp;</div>
            <el-input
              v-else
              :ref="'input-' + scope.row.originIndex + '-colorCode'"
              v-model="scope.row.colorCode.value"
              @change="onChangeColorCode(scope.row.colorCode.value, scope.row.colorCode)"
              @click.native.stop=""
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="discount" label="折扣" class-name="nopadding" align="right">
          <template slot-scope="scope">
            <div class="item-cell" :class="{error: scope.row.discount.error, 'changed': scope.row.discount.value != scope.row.discount.oldValue}"
              v-if="!scope.row.discount.isEdit"
              @click="onClickCell3(scope, 'discount', $event)"
            >{{ scope.row.discount.value }}&nbsp;</div>
            <el-input
              v-else
              :ref="'input-' + scope.row.originIndex + '-discount'"
              v-model="scope.row.discount.value"
              @input="(val) => inputNum(val, scope.row.discount)"
              @change="checkTableData3"
              @click.native.stop=""
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="empty" label="" class-name="nopadding"></el-table-column>
        <el-table-column prop="error" width="50">
          <template slot-scope="scope">
            <el-popover
              v-if="scope.row.error"
              placement="top-start"
              width="200"
              trigger="hover"
              :content="scope.row.errorMessage">
              <i slot="reference" class="el-icon-warning red"></i>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="error" width="40">
          <template slot-scope="scope">
            <i class="el-icon-remove-outline" @click="onClickRemove3(scope)"></i>
          </template>
        </el-table-column>
      </VirtualScrollTable>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import {
  category,
  getAllCategory2,
  getAllCategory3,
  getBoutiqueProductRate,
  getPromotionVendorDiscountCategory2List,
  getPromotionVendorDiscountCategory3List,
  getPromotionVendorDiscountSpecialProductList,
  submitBoutiqueProductDiscount,
  submitPromotionVendorDiscountDetail,
  checkPriceChangeRule,
} from '../api.js'
import {
  getBrandList,
} from '../../seller/api.js';
import VirtualScrollTable from '../../shared/VirtualScrollTableNew.vue';
import BrandSelect from '../../shared/brandSelect.vue';

export default {
  components: {
    VirtualScrollTable,
    BrandSelect,
  },
  data() {
    return {
      page: this.$route.query.page,
      routeQuery: this.$route.query,
      supplyPriceMethod: this.$route.query.supplyPriceMethod,
      fullscreenLoading: false,
      currentPage: 1,
      pageSize: 15,
      loading: false,
      tableData1: [],
      tableData2: [],
      tableData3: [],
      header: [],
      activeName: 'first',
      brandList: [],
      brandMap: {},
      categoryList: [],
      categoryMap: {},
      optionProps: {
        expandTrigger: "hover",
        emitPath: false,
        checkStrictly: false,
        multiple: false,
        label: 'chineseName',
        value: 'categoryId',
      },
      hasPending: false, // 是否有待生效折扣
      tableData1Loaded: false,
      tableData2Loaded: false,
      tableData3Loaded: false,
    };
  },
  computed: {
    ...mapState({
      submitBtnDaily: (state) => state.app.menuMap['折扣管理-daily-discount-提交'],
      submitBtnPromotion: (state) => state.app.menuMap['折扣管理-活动折扣-提交'],
    }),
    changedTable1() {
      return (
        this.tableData1Loaded &&
        (this.tableData1.length !== this.tableData1Total ||
        this.tableData1.some(row => {
          return row.brandId.value != row.brandId.oldValue || this.header.some(headerItem => {
            return row[headerItem.value].value != row[headerItem.value].oldValue;
          });
        }))
      )
    },
    changedTable2() {
      return (
        this.tableData2Loaded &&
        (
          this.tableData2.length !== this.tableData2Total ||
          this.tableData2.some(row => {
            return row.brandId.value != row.brandId.oldValue || row.categoryId.value != row.categoryId.oldValue || row.discount.value != row.discount.oldValue;
          })
        )
      );
    },
    changedTable3() {
      return (
        this.tableData3Loaded &&
        (
          this.tableData3.length !== this.tableData3Total ||
          this.tableData3.some(row => {
            return row.designerId.value != row.designerId.oldValue || row.colorCode.value != row.colorCode.oldValue || row.discount.value != row.discount.oldValue;
          })
        )
      );
    },
    brandListWithDefault() {
      return [{
        label: 'Default',
        value: 0,
      }, ...this.brandList];
    },
  },
  created() {
    this.supplyPriceMethod = this.$route.query.supplyPriceMethod;
    this.getCategoryList();
    getBrandList().then((res) => {
      this.brandList = (res.data || []).map(item => {
        return {
          label: item.englishName,
          value: item.brandId,
        };
      });
      this.brandMap = res.data.reduce((acc, cur) => {
        acc[cur.brandId] = cur.englishName;
        return acc;
      }, {
        0: 'Default',
      });
    });
    if (this.page === 'daily') {
      checkPriceChangeRule(this.routeQuery.id).then(res => {
        if (res.data) {
          this.hasPending = res.data.hasPending;
          if (res.data.runStatus == 2) {
            this.$message('当前折扣计算中无法提交，请稍后处理');
          }
        }
      })
    }
  },
  mounted() {
    window.addEventListener("click", this.onClickPage);
  },
  beforeDestroy() {
    window.removeEventListener("click", this.onClickPage);
  },
  methods: {
    async getCategoryList() {
      const res = (await category()).data;
      const map = {};
      const categoryList = (res || []).map((item) => {
        if (item.children && item.children.length > 0) {
          item.children.forEach((item2) => {
            if (item2.children && item2.children.length > 0) {
              item2.children.forEach((item3) => {
                map[item3.categoryId] = `${item.chineseName}>${item2.chineseName}>${item3.chineseName}`;
              });
            } else {
              item2.children = null;
            }
          });
        } else {
          item.children = null;
        }
        return item;
      });
      this.categoryMap = map;
      const temp = categoryList.filter(item => {
        return this.routeQuery.categoryType == 1 ? ![1757, 1758, 1759].includes(item.categoryId) : [1757, 1758, 1759].includes(item.categoryId);
      })
      this.categoryList = temp;
      const arr = []
      for (let index = 0; index < temp.length; index++) {
        const el = temp[index];
        for (let j = 0; j < el.children.length; j++) {
          const element = el.children[j];
          arr.push({ label: el.chineseName + '-' + element.chineseName, value: element.categoryId });
        }
      }
      this.header = arr;
      console.log(this.header);
      this.getTableData();
    },
    handleClick(tab, event) {
    },
    async reset() {
      const result = await this.$confirm('确认放弃当前所有修改？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
      if (!result) { return }
      this.onClickPage();
      this.getTableData();
    },
    async getTableData() {
      this.getTableData1();
      this.getTableData2();
      this.getTableData3();
    },
    async getTableData1() {
      this.loading = true;
      const id = this.routeQuery.id;
      let request = getAllCategory2;
      if (this.page === 'promotion') {
        request = getPromotionVendorDiscountCategory2List;
      }
      this.autoIncrement1 = 0;
      const resData = (await request(id)).data;
      this.tableData1 = resData.map(item => {
        const row = {
          error: false, // 行错误标识
          errorMessage: '', // 行错误消息
          originIndex: this.autoIncrement1++,
        };
        row.brandId = {
          isEdit: false,
          value: item.brandId,
          error: false, // 错误
          oldValue: item.brandId, // 旧值
        };
        this.header.forEach((headerItem) => {
          row[headerItem.value] = {
            isEdit: false,
            value: item[headerItem.value],
            error: false,
            oldValue: item[headerItem.value], // 旧值
          };
        });
        return row;
      });
      this.tableData1Total = this.tableData1.length;
      this.tableData1Loaded = true;
      this.loading = false;
    },
    async getTableData2() {
      const id = this.routeQuery.id;
      let request = getAllCategory3;
      if (this.page === 'promotion') {
        request = getPromotionVendorDiscountCategory3List;
      }
      this.autoIncrement2 = 0;
      const resData = (await request(id)).data;
      this.tableData2 = resData.map(item => {
        const row = {
          error: false,
          errorMessage: '',
          originIndex: this.autoIncrement2++,

          brandId: {
            isEdit: false,
            value: item.brandId,
            error: false, // 错误
            oldValue: item.brandId, // 旧值
          },
          categoryId: {
            isEdit: false,
            value: item.categoryId,
            error: false, // 错误
            oldValue: item.categoryId, // 旧值
          },
          discount: {
            isEdit: false,
            value: item.discount,
            error: false, // 错误
            oldValue: item.discount, // 旧值
          },
        };
        return row;
      });
      this.tableData2Total = this.tableData2.length;
      this.tableData2Loaded = true;
    },
    async getTableData3() {
      const id = this.routeQuery.id;
      let request = getBoutiqueProductRate;
      if (this.page === 'promotion') {
        request = getPromotionVendorDiscountSpecialProductList;
      }
      this.autoIncrement3 = 0;
      const resData = (await request(id)).data;
      this.tableData3 = resData.map(item => {
        const row = {
          error: false,
          errorMessage: '',
          originIndex: this.autoIncrement3++,

          designerId: {
            isEdit: false,
            value: item.designerId,
            error: false, // 错误
            oldValue: item.designerId, // 旧值
          },
          colorCode: {
            isEdit: false,
            value: item.colorCode,
            error: false, // 错误
            oldValue: item.colorCode, // 旧值
          },
          discount: {
            isEdit: false,
            value: item.discount,
            error: false, // 错误
            oldValue: item.discount, // 旧值
          },
        };
        return row;
      });
      this.tableData3Total = this.tableData3.length;
      this.tableData3Loaded = true;
    },
    onClickPage() {
      this.tableData1.forEach((row) => {
        row.brandId.isEdit = false;
        this.header.forEach((headerItem) => {
          row[headerItem.value].isEdit = false;
        });
      });
      this.tableData2.forEach((row) => {
        row.brandId.isEdit = false;
        row.categoryId.isEdit = false;
        row.discount.isEdit = false;
      });
      this.tableData3.forEach((row) => {
        row.designerId.isEdit = false;
        row.colorCode.isEdit = false;
        row.discount.isEdit = false;
      });
    },
    onClickCell1(scope, key, event) {
      event.stopPropagation();
      this.tableData1.forEach((row) => {
        if (key === 'brandId') {
          if (scope.row.originIndex === row.originIndex) {
            row.brandId.isEdit = true;
          } else {
            row.brandId.isEdit = false;
          }
        } else {
          this.header.forEach((headerItem) => {
            // TODO 留意虚拟表格滚动的影响
            if (scope.row.originIndex === row.originIndex && key == headerItem.value) {
              row[headerItem.value].isEdit = true;
            } else {
              row[headerItem.value].isEdit = false;
            }
          });
        }
      });
      this.$nextTick(() => {
        if (key !== 'brandId') {
          this.$refs[`input-${scope.row.originIndex}-${key}`][0].select();
        }
      })
    },
    onClickCell2(scope, key, event) {
      event.stopPropagation();
      this.tableData2.forEach((row) => {
        // TODO 留意虚拟表格滚动的影响
        if (scope.row.originIndex === row.originIndex) {
          row[key].isEdit = true;
        } else {
          row[key].isEdit = false;
        }
      });
      this.$nextTick(() => {
        if (key === 'discount') {
          this.$refs[`input-${scope.row.originIndex}-${key}`].select();
        }
      })
    },
    onClickCell3(scope, key, event) {
      event.stopPropagation();
      this.tableData3.forEach((row) => {
        // TODO 留意虚拟表格滚动的影响
        if (scope.row.originIndex === row.originIndex) {
          row[key].isEdit = true;
        } else {
          row[key].isEdit = false;
        }
      });
      this.$nextTick(() => {
        this.$refs[`input-${scope.row.originIndex}-${key}`].select();
      })
    },
    inputNum(val, cell) {
      if (this.supplyPriceMethod == 2) {
        this.inputNum2(val, cell)
      } else {
        this.inputNum1(val, cell)
     }
    },
    inputNum1(val, cell) {
      // val = `${val}`.replace(/[^\d]/g, '');
      // 移除非数字和非小数点字符
      val = `${val}`.replace(/[^\d.]/g, '');
      // 确保小数点后最多两位
      var parts = val.split('.');
      if (parts.length > 1) {
          parts[1] = parts[1].substring(0, 2); // 截取小数点后两位
          val = parts.join('.');
      }
      // 确保只有一个小数点
      var decimalCount = (val.match(/\./g) || []).length;
      if (decimalCount > 1) {
        val = val.substr(0, val.lastIndexOf('.'));
      }
      // 如果小数点位于数字的最前面，添加整数部分
      if (val.startsWith('.')) {
        val = '0' + val
      }

      // 确保输入不超过100
      if (Number(val) >= 100) {
        val = 99;
      }
      if (val == '') {
        cell.value = null;
      } else {
        // val = Number(val);
        // if (val > 99) {
        //   val = 99;
        // }
        cell.value = val;
      }
    },
    inputNum2(val, cell) {
      // val = `${val}`.replace(/[^\d]/g, '');
      // 移除非数字和非小数点字符
      val = `${val}`.replace(/[^\d.-]/g, '');
      // 确保小数点后最多两位
      var parts = val.split('.');
      if (parts.length > 1) {
          parts[1] = parts[1].substring(0, 2); // 截取小数点后两位
          val = parts.join('.');
      }
      // 确保只有一个小数点
      var decimalCount = (val.match(/\./g) || []).length;
      if (decimalCount > 1) {
        val = val.substr(0, val.lastIndexOf('.'));
      }
      // 如果小数点位于数字的最前面，添加整数部分
      if (val.startsWith('.')) {
        val = '0' + val
      }

      // 确保输入不超过100
      if (Math.abs(Number(val)) >= 100) {
        val = 99;
      }
      if (val == '') {
        cell.value = null;
      } else {
        // val = Number(val);
        // if (val > 99) {
        //   val = 99;
        // }
        cell.value = val;
      }
    },
    onChangeDesignId(val, cell) {
      cell.value = val.trim();
      this.checkTableData3();
    },
    onChangeColorCode(val, cell) {
      cell.value = val.trim();
      this.checkTableData3();
    },
    getDisabledBrandIds1(val) {
      return this.tableData1.map(item => item.brandId.value).filter(item => item != val);
    },
    checkTableData1() {
      this.tableData1.forEach(row => {
        row.error = false;
        row.errorMessage = '';
        if (row.brandId.value == 0) { // Default 校验
          let flag = false; // 为空
          this.header.forEach((headerItem) => {
            row[headerItem.value].error = false;
            if ((row[headerItem.value].value == '' || row[headerItem.value].value == null) && row[headerItem.value].value != 0) {
              flag = true;
              row[headerItem.value].error = true;
            }
          });
          if (flag) {
            row.errorMessage = 'Default 所有折扣必填；';
            row.error = flag;
          }
        } else { // 其他品牌校验
          row.brandId.error = false;
          if (!row.brandId.value) {
            row.error = true;
            row.errorMessage = '品牌必选；';
            row.brandId.error = true;
          }
          const discountError = this.header.every((headerItem) => {
            if ((row[headerItem.value].value == '' || row[headerItem.value].value == null) && row[headerItem.value].value != 0) {
              return true;
            }
            return false;
          });
          row.error = row.error || discountError;
          if (discountError) {
            row.errorMessage += '当前行的折扣至少需要设置一个折扣；';
          }
          this.header.forEach((headerItem) => {
            row[headerItem.value].error = discountError;
          });
        }
      });
    },
    checkTableData2() {
      const brandIdAndCategoryIdList = this.tableData2.filter(item => (item.brandId.value || item.brandId.value === 0) && item.categoryId.value).map(item => {
        return `${item.brandId.value}-${item.categoryId.value}`;
      });
      // 找出brandIdAndCategoryIdList中的重复元素
      const repeatList = brandIdAndCategoryIdList.filter((item, index) => {
        return brandIdAndCategoryIdList.indexOf(item) != index;
      });
      this.tableData2.forEach(row => {
        row.error = false;
        row.errorMessage = '';
        row.brandId.error = false;
        if (!row.brandId.value && row.brandId.value != 0) {
          row.error = true;
          row.errorMessage = '品牌必选；';
          row.brandId.error = true;
        }
        row.categoryId.error = false;
        if (!row.categoryId.value) {
          row.error = true;
          row.errorMessage += '类目必选；';
          row.categoryId.error = true;
        }
        repeatList.forEach(item => {
          const arr = item.split('-');
          if (row.brandId.value == arr[0] && row.categoryId.value == arr[1]) {
            row.error = true;
            row.errorMessage += '品牌+类目重复；';
            row.brandId.error = true;
            row.categoryId.error = true;
          }
        });
        row.discount.error = false;
        if ((row.discount.value == '' || row.discount.value == null) && row.discount.value != 0) {
          row.error = true;
          row.errorMessage += '折扣必填；';
          row.discount.error = true;
        }
      });
    },
    checkTableData3() {
      const designerIdAndColorCodeList = this.tableData3.filter(item => item.designerId.value && item.colorCode.value).map(item => {
        return `${item.designerId.value}-${item.colorCode.value}`;
      });
      // 找出designerIdAndColorCodeList中的重复项
      const repeatList = designerIdAndColorCodeList.filter((item, index) => {
        return designerIdAndColorCodeList.indexOf(item) != index;
      });
      this.tableData3.forEach(row => {
        row.error = false;
        row.errorMessage = '';
        row.designerId.error = false;
        if (!row.designerId.value) {
          row.error = true;
          row.errorMessage = '货号必填；';
          row.designerId.error = true;
        }
        row.colorCode.error = false;
        if (!row.colorCode.value) {
          row.error = true;
          row.errorMessage += '色号必填；';
          row.colorCode.error = true;
        }
        repeatList.forEach(item => {
          const arr = item.split('-');
          if (row.designerId.value == arr[0] && row.colorCode.value == arr[1]) {
            row.error = true;
            row.errorMessage += '货号+色号重复；';
            row.designerId.error = true;
            row.colorCode.error = true;
          }
        });
        row.discount.error = false;
        if ((row.discount.value == '' || row.discount.value == null) && row.discount.value != 0) {
          row.error = true;
          row.errorMessage += '折扣必填；';
          row.discount.error = true;
        }
      });
    },
    onClickRemove1(scope) {
      this.tableData1.splice(this.tableData1.findIndex(item => item.originIndex === scope.row.originIndex), 1);
      this.checkTableData1();
    },
    onClickRemove2(scope) {
      this.tableData2.splice(this.tableData2.findIndex(item => item.originIndex === scope.row.originIndex), 1);
      this.checkTableData2();
    },
    onClickRemove3(scope) {
      this.tableData3.splice(this.tableData3.findIndex(item => item.originIndex === scope.row.originIndex), 1);
      this.checkTableData3();
    },
    onClickAdd() {
      if (this.activeName === 'first') {
        const row = {
          brandId: {
            isEdit: false,
            value: null,
            error: true,
            oldValue: null, // 旧值
          },
          error: true,
          errorMessage: '品牌必选；当前行的折扣至少需要设置一个折扣；',
          originIndex: this.autoIncrement1++,
        };
        this.header.forEach((headerItem) => {
          row[headerItem.value] = {
            isEdit: false,
            value: null,
            error: true,
            oldValue: null, // 旧值
          };
        });
        this.tableData1.push(row);
        this.$nextTick(() => {
          this.$refs.VirtualScrollTable1.scrollToBottom();
        })
      }
      if (this.activeName === 'second') {
        const row = {
          brandId: {
            isEdit: false,
            value: null,
            error: true, // 错误
            oldValue: null, // 旧值
          },
          categoryId: {
            isEdit: false,
            value: null,
            error: true, // 错误
            oldValue: null, // 旧值
          },
          discount: {
            isEdit: false,
            value: null,
            error: true, // 错误
            oldValue: null, // 旧值
          },
          error: false,
          errorMessage: '品牌必选；类目必选；折扣必填；',
          originIndex: this.autoIncrement2++,
        };
        this.tableData2.push(row);
        this.$nextTick(() => {
          this.$refs.VirtualScrollTable2.scrollToBottom();
        })
      }
      if (this.activeName === 'third') {
        const row = {
          designerId: {
            isEdit: false,
            value: null,
            error: true, // 错误
            oldValue: null, // 旧值
          },
          colorCode: {
            isEdit: false,
            value: null,
            error: true, // 错误
            oldValue: null, // 旧值
          },
          discount: {
            isEdit: false,
            value: null,
            error: true, // 错误
            oldValue: null, // 旧值
          },
          error: true,
          errorMessage: '货号必填；色号必填；折扣必填；',
          originIndex: this.autoIncrement3++,
        };
        this.tableData3.push(row);
        this.$nextTick(() => {
          this.$refs.VirtualScrollTable3.scrollToBottom();
        })
      }
    },
    async submitPage() {
      this.checkTableData1();
      this.checkTableData2();
      this.checkTableData3();
      const error1 = this.tableData1.some(item => item.error);
      const error2 = this.tableData2.some(item => item.error);
      const error3 = this.tableData3.some(item => item.error);
      if (error1) {
        this.$message.error('当前设置有错误，请处理后提交；请检查二级类目');
        return;
      }
      if (error2) {
        this.$message.error('当前设置有错误，请处理后提交；请检查三级类目');
        return;
      }
      if (error3) {
        this.$message.error('当前设置有错误，请处理后提交；请检查特殊商品');
        return;
      }
      if (this.page === 'promotion') {
        const result = await this.$confirm('确认提交？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        });
        if (!result) {
          return;
        }
      } else if (this.page === 'daily') {
        const checkRes = await checkPriceChangeRule(this.routeQuery.id);
        if (checkRes.data && checkRes.data.runStatus == 2) {
          this.$message('当前折扣计算中无法提交，请稍后处理');
          return;
        }
        let msg = '确认提交？';
        if (!checkRes.success) {
          this.$message.error(checkRes.message || '系统异常，请稍后再试');
          return;
        }
        if (this.routeQuery.status == '2' && checkRes.data && checkRes.data.hasPending) {
          msg = '确认提交？提交后，当前折扣立即生效，且当前待生效折扣失效（<span style="color:red">请确认是否需下载待生效折扣文件</span>)';
        }
        if (this.routeQuery.status == '2' && checkRes.data && !checkRes.data.hasPending) {
          msg = '确认提交？提交后，当前折扣立即生效';
        }
        const result = await this.$confirm(msg, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          dangerouslyUseHTMLString: true,
          type: 'warning',
        });
        if (!result) {
          return;
        }
      }
      const secondCategroyDiscountList = this.tableData1.map((row) => {
        const obj = {
          brandId: row.brandId.value,
        };
        this.header.forEach((headerItem) => {
          if (row[headerItem.value].value !== '' && row[headerItem.value].value !== null) {
            obj[headerItem.value] = row[headerItem.value].value;
          }
        });
        return obj;
      });
      const thirdCategroyDiscountList = this.tableData2.map((row) => {
        return {
          brandId: row.brandId.value,
          categoryId: row.categoryId.value,
          discount: row.discount.value,
        };
      });
      const specialProductDiscountList = this.tableData3.map((row) => {
        return {
          designerId: row.designerId.value,
          colorCode: row.colorCode.value,
          discount: row.discount.value,
        };
      });
      if (this.repeatSubmit) {
        return;
      }
      this.repeatSubmit = true;
      this.fullscreenLoading = true;
      if (this.page === 'daily') {
        submitBoutiqueProductDiscount({
          priceChangeRuleId: this.routeQuery.id,
          secondCategroyDiscountList,
          thirdCategroyDiscountList,
          specialProductDiscountList,
        }).then((res) => {
          this.fullscreenLoading = false;
          this.$message.success('提交成功');
          this.onClickPage();
          this.getTableData();
          setTimeout(() => {
            this.repeatSubmit = false;
          }, 2000);
        }).catch((err) => {
          this.repeatSubmit = false;
          this.fullscreenLoading = false;
        })
      } else if (this.page === 'promotion') {
        submitPromotionVendorDiscountDetail(this.routeQuery.id, {
          secondCategoryRuleVoList: secondCategroyDiscountList,
          thirdCategoryRuleVoList: thirdCategroyDiscountList,
          productRuleVoList: specialProductDiscountList,
        }).then((res) => {
          this.fullscreenLoading = false;
          this.$message.success('提交成功');
          this.onClickPage();
          this.getTableData();
          setTimeout(() => {
            this.repeatSubmit = false;
          }, 2000);
        }).catch((err) => {
          this.repeatSubmit = false;
          this.fullscreenLoading = false;
        })
      }
    },
  },
};
</script>
<style scoped lang="less">
.f14 {
  font-size: 14px;
}
.red {
  color: #F56C6C;
}
.gray {
  color: #909399;
}
.pl10 {
  padding-left: 10px;
}
.mt10 {
  margin-top: 10px;
}
.mt15 {
  margin-top: 15px;
}
.mb10 {
  margin-bottom: 10px;
}
.mb15 {
  margin-bottom: 15px;
}
.ml20 {
  margin-left: 20px;
}
.discount-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding:10px 20px 10px 20px
}
.label {
  font-size: 12px;
}
.value {
  margin-right: 20px;
  font-size: 14px;
  font-weight: 500;
}
.toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.table-container {
  flex: 1;
}
.item-cell {
  height: 43px;
  line-height: 43px;
  white-space: pre-wrap;

  &.changed {
    border-bottom: 1px dashed #909399;
  }
  &.error {
    border-bottom: 1px solid #F56C6C;
  }
}
.item-cell:active {
  background-color: rgba(0, 0, 0, 0.1);
}
</style>
